import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../styles/theme';

import logo from '../../../assets/LPDlogo.png';

const LPDLogo = styled.img`
    width: 20%;
    max-width: 200px;
    min-width: 150px;
    height: 100%;
`;

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.regular};
    font-weight: ${props => props.theme.font.weight.regular};
`;

const Title = styled.h1`
    justify-content: center;
    font-size: ${props => props.theme.font.size.large};
    padding: 0;
    margin: 0;
`;

const SubTitle = styled.h3`
    font-size: ${props => props.theme.font.size.small};
    padding: 0;
    margin: 0;
    @media screen and (max-width: 645px) {
        display: none;
    }
`;

const Top = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: ${props => props.theme.font.weight.semiBold};
    font-size: ${props => props.theme.font.size.small};
`;

const HeaderTextBox = styled.div`  
    display: flex;  
    flex-direction: column;  
    justify-content: center;  
    align-items: center;  
    width: 80%;  
`;

const DivisionInfoContainer = styled.div`
    display: flex;  
    flex-direction: row;  
    justify-content: space-evenly;  
    align-items: center;  
    width: 100%;  
    font-size: ${props => props.theme.font.size.regular};
    @media screen and (max-width: 645px) {
        display: none;
    }
`;

const DivisionInfoBox = styled.div`
    font-size: ${props => props.theme.font.size.small};
    display: flex;
    flex-Direction: column;
    align-items: center;
`;

const Info = styled.p`
    padding: 0;
    margin: 0;

`;

const RowContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-item: space-evenly;
`;

const Bold= styled.span`
    font-weight: ${props => props.theme.font.weight.bold};
    font-size: ${props => props.theme.font.size.regular};
`;

interface ReportHeaderProps {
    caseNumber: string;
}

const ReportHeader: React.FC<ReportHeaderProps> = ({ caseNumber }) => {
    return (
        <ThemeProvider theme={theme}>
            <HeaderContainer>
                <Top>
                    <Info>
                        <Bold>Basic Copy</Bold>
                    </Info>
                    <div>
                        <Info>Case No:</Info>
                        <Info>
                            <Bold>{caseNumber}</Bold>
                        </Info>
                    </div>
                </Top>
                <RowContainer>
                    <LPDLogo src={logo} alt="LPD Logo" />
                    <HeaderTextBox>
                        <Title>
                            Lubbock Police Department
                        </Title>
                        <DivisionInfoContainer>
                            <DivisionInfoBox>
                                <SubTitle>
                                    Headquarters
                                </SubTitle>
                                <Info>1205 15th Street</Info>
                                <Info>Lubbock TX 79401</Info>
                                <Info>(806) 775-2816</Info>
                            </DivisionInfoBox>
                            <DivisionInfoBox>
                                <SubTitle>
                                    East Division
                                </SubTitle>
                                <Info>1901 MLK Blvd.</Info>
                                <Info>Lubbock TX 79403</Info>
                                <Info>(806) 775-3483</Info>
                            </DivisionInfoBox>
                            <DivisionInfoBox>
                                <SubTitle>
                                    South Division
                                </SubTitle>
                                <Info>14005 Indiana Ave.</Info>
                                <Info>Lubbock TX 79423</Info>
                                <Info>(806) 775-3482</Info>
                            </DivisionInfoBox>
                            <DivisionInfoBox>
                                <SubTitle>
                                    North Division
                                </SubTitle>
                                <Info>5910 Erskine St.</Info>
                                <Info>Lubbock TX 79416</Info>
                                <Info>(806) 775-3481</Info>
                            </DivisionInfoBox>
                        </DivisionInfoContainer>
                    </HeaderTextBox>
                </RowContainer>
            </HeaderContainer>
        </ThemeProvider>
    );
}

export default ReportHeader;;